/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  ViewContainerRef,
  Input,
  ViewChild,
  OnInit,
  Type,
  ChangeDetectorRef,
  inject
} from '@angular/core';
import { GenericColumnConfiguration } from 'src/app/models/GenericColumnConfiguration';
import { SHARED_IMPORTS } from 'src/app/utils/other/standalone-import';

@Component({
  selector: 'app-dynamic-form-comp',
  template: ` <ng-container #dynamicComponentContainer></ng-container>`,
  styleUrl: './dynamic-form-comp.component.scss',
  standalone: true,
  imports: [SHARED_IMPORTS]
})
export class DynamicFormCompComponent implements OnInit {
  /**
   * The configuration for the column, including the component type and parameters.
   * @type {GenericColumnConfiguration}
   */
  @Input({ required: true }) columnConfig!: GenericColumnConfiguration;

  /**
   * The object to edit.
   */
  @Input({ required: true }) editObject!: any;

  /**
   * The container to dynamically insert the component.
   */
  @ViewChild('dynamicComponentContainer', {
    read: ViewContainerRef,
    static: true
  })
  container!: ViewContainerRef;

  private cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    // Check if the form configuration includes a component type
    if (
      this.columnConfig.type === 'component' &&
      this.columnConfig.formComponent
    ) {
      // Create the component dynamically
      const componentRef = this.container.createComponent(
        this.columnConfig.formComponent as Type<unknown>
      );

      // Assign component parameters if provided in configuration
      if (this.columnConfig.formComponentParams) {
        Object.entries(this.columnConfig.formComponentParams).forEach(
          ([key, value]) => {
            try {
              // Set the parameter on the component instance
              (componentRef.instance as any)[key] = value;
            } catch (error) {
              console.error(
                `Error setting property ${key} on component:`,
                error
              );
            }
          }
        );
      }

      // Attach column configuration if `referringKey` is present
      if (this.columnConfig.referringKey) {
        (componentRef.instance as any).columnConfiguration = this.columnConfig;
      }

      // Attach editObject
      if (this.columnConfig.formComponentParams?.['editObjectKey']) {
        (componentRef.instance as any)[
          this.columnConfig.formComponentParams['editObjectKey']
        ] = this.editObject;
      }

      (componentRef.instance as any).editObject = this.editObject;

      // Trigger change detection to ensure inputs are processed
      this.cdr.detectChanges();
    }
  }
}
